import * as React from "react";
import classnames from "classnames";
import { Util, useDrawer, Button } from "@grandvisionhq/common";
/* empty css                         */
const FacetsMobileTrigger = React.forwardRef(
  ({ onClick, caption }, outerRef) => {
    const [isSticky, setSticky] = React.useState(false);
    const innerRef = React.useRef(null);
    React.useImperativeHandle(outerRef, () => innerRef.current, []);
    const { isHidden: isHeaderHidden } = Util.useHeaderOnScroll(true);
    const { toggle } = useDrawer();
    const handleClick = () => {
      onClick();
      toggle();
    };
    const handleScroll = React.useCallback(() => {
      if (innerRef?.current) {
        const benchmark = isHeaderHidden ? 0 : 62;
        const isSticky2 = innerRef.current.getBoundingClientRect().top < benchmark;
        setSticky(isSticky2);
      }
    }, [isHeaderHidden, setSticky, innerRef]);
    React.useEffect(() => {
      window.addEventListener("scroll", handleScroll);
      return () => window.removeEventListener("scroll", handleScroll);
    }, [handleScroll]);
    return /* @__PURE__ */ React.createElement("div", { className: "facets-mobile-trigger", ref: innerRef }, /* @__PURE__ */ React.createElement(
      "div",
      {
        className: classnames({
          "facets-mobile-trigger__sticky": isSticky,
          "facets-mobile-trigger__sticky--with-header": !isHeaderHidden && isSticky
        })
      },
      /* @__PURE__ */ React.createElement(
        Button,
        {
          className: "facets-mobile-trigger__button",
          "data-t": "facets-mobile-button",
          caption,
          icon: "filter",
          onClick: handleClick
        }
      )
    ));
  }
);
export {
  FacetsMobileTrigger
};
//# sourceMappingURL=FacetsMobileTrigger.js.map
